import { render, staticRenderFns } from "./ModalListComponent.vue?vue&type=template&id=45dbdbd2&scoped=true"
import script from "./ModalListComponent.vue?vue&type=script&lang=js"
export * from "./ModalListComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalListComponent.vue?vue&type=style&index=1&id=45dbdbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dbdbd2",
  null
  
)

export default component.exports